import {scrubContactData} from '../summary/scrubContactData';
import {compactDate, formatUtc, nextDay, type IcsStart} from './ics';

export interface GoogleCalendarEvent {
    title: string;
    start: IcsStart;
    durationMinutes: number;
    location?: string | null;
    details: string;
}

export const googleCalendarLink = (event: GoogleCalendarEvent): string => {
    const dates = event.start.kind === 'datetime'
        ? `${formatUtc(event.start.utc)}/${formatUtc(new Date(event.start.utc.getTime() + event.durationMinutes * 60_000))}`
        : `${compactDate(event.start.date)}/${compactDate(nextDay(event.start.date))}`;
    const params = new URLSearchParams({action: 'TEMPLATE', text: scrubContactData(event.title), dates, details: scrubContactData(event.details)});
    const location = event.location ? scrubContactData(event.location) : '';
    if (location) params.set('location', location);
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
};
